import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiRoute } from "../util/constant";
import { AxiosInstanceService } from "../services/axiosInstance";

export const getMangeDataAction = createAsyncThunk(
    'manageV2/data',
    async ({ mode, query }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.get(`${apiRoute.getManage}${mode}/page?${query}`)
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);




export const getMangeDataByIdAction = createAsyncThunk(
    'manageV2/dataById',
    async ({ mode, id }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.get(`${apiRoute.getManage}${mode}/${id}`)
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);










export const updateManageByIdAction = createAsyncThunk(
    'manageV2/edit',
    async ({ mode, id, data }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.put(`${apiRoute.updateDeleteAddManage}${mode}/${id}`, {
                ...data
            })
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);

export const updatePasswordByIdAction = createAsyncThunk(
    'manageV2/updatePassword',
    async ({ mode, id, data }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.put(`${apiRoute.updateDeleteAddManage}${mode}/changePassword/${id}`, {
                ...data
            })
            return response.data;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);


// Finish Job by ID (PUT /api/job/Finished/{id})
export const finishJobByIdAction = createAsyncThunk(
    'manageV2/finishJob',
    async ({ id, containers, startDate }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const body = Array.isArray(containers) ? containers : undefined;
            const qs = startDate ? `?startDate=${encodeURIComponent(startDate)}` : '';
            const response = await instance.put(`${apiRoute.updateDeleteAddManage}job/Finished/${id}${qs}`, body);
            return response.data;
        } catch (error) {
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);

// Mark shipment as departed (PATCH /api/shipment/{id}/departed)
export const markShipmentDepartedAction = createAsyncThunk(
    'manageV2/markShipmentDeparted',
    async ({ id }, { rejectWithValue }) => {
        try {
            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.patch(`${apiRoute.updateDeleteAddManage}shipment/${id}/departed`);
            return response.data;
        } catch (error) {
            if (error.response && error.response.data && (error.response.data.message || error.response.data.error)) {
                return rejectWithValue(error.response.data.message || error.response.data.error);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);




















export const deleteManageByIdAction = createAsyncThunk(
    'manageV2/delete',
    async ({ mode, id, moveId = null }, { rejectWithValue }) => { // set default value of moveId to null
        try {
            let url = `${apiRoute.updateDeleteAddManage}${mode}/${id}`;

            // If moveId is not null, append it to the url
            if (moveId !== null) {
                url += `/${moveId}`;
            }

            const instance = await AxiosInstanceService.getAxiosInstance();
            const response = await instance.delete(url);
            return response.data;
        } catch (error) {
            // Return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);








export const addManageAction = createAsyncThunk(
    'manageV2/add',
    async ({ mode, parentId, data }, { rejectWithValue }) => {
        try {

            const instance = await AxiosInstanceService.getAxiosInstance();
            // let response = null;
            if (parentId) {
                const response = await instance.post(`${apiRoute.updateDeleteAddManage}${mode}?parentId=${parentId}`, {
                    ...data
                })
                return response.data;
            }
            const response = await instance.post(`${apiRoute.updateDeleteAddManage}${mode}`, {
                ...data

            })
            return response.data;

        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
);


